<script lang="ts">
  import {createEventDispatcher, onDestroy, onMount} from 'svelte';
  import Element from './Element.svelte';
  import Sentence from './Subtitle/Sentence.svelte';
  import {translate} from './Util';
  import Moveable from 'moveable';

  export let properties: any = {};

  const dispatch = createEventDispatcher();

  let transform = '';

  $: if (properties.position) {
    transform = translate(properties.position);
  }

  let element: HTMLDivElement;
  let moveable: Moveable;

  const defaultFontFamily = `ui-sans-serif, system-ui, sans-serif`;

  onMount(() => {
    const parentElement = element.parentElement;
    if (!parentElement) return {error: new Error('parent element not found'), moveable: null};

    moveable = new Moveable(parentElement, {
      target: element,
      draggable: true,
      resizable: true,
      scalable: true,
      rotatable: true,
      warpable: true,
      pinchable: true,
      origin: true,
      edge: false,
      throttleDrag: 0,
      throttleResize: 0,
      throttleScale: 0,
      throttleRotate: 0,
      useResizeObserver: true
    });

    moveable
      .on('drag', event => {
        properties.position.x = event.translate[0];
        properties.position.y = -event.translate[1];
        event.target.style.transform = `transform: ${translate(properties.position)};`;
        properties = properties;
      })
      .on('dragEnd', event => {
        dispatch('propertiesUpdate', properties);
      })
      .on('resize', event => {
        if (event.width > 0) {
          properties.width = event.width;
          event.target.style.width = `${typeof properties.width === 'number' ? `${properties.width}px` : properties.width}`;
        }
        if (event.height > 0) {
          properties.height = event.height;
          event.target.style.height = `${typeof properties.height === 'number' ? `${properties.height}px` : properties.height}`;
        }
        console.log({height: properties.height, width: properties.width}, 'Subtitle Resize');

        properties = properties;
      })
      .on('resizeEnd', event => {
        dispatch('propertiesUpdate', properties);
      });
  });

  onDestroy(() => {
    moveable.destroy();
  });
</script>

<Element>
  <div
    bind:this={element}
    class="relative flex items-center justify-center text-center font-bold"
    style={`height: ${typeof properties.height === 'string' ? properties.height : `${properties.height}px`}; width: ${typeof properties.width === 'string' ? properties.width : `${properties.width}px`}; transform: ${transform}; color: ${properties.textColor || 'white'}; font-family: ${properties.fontFamily === 'default' ? defaultFontFamily : properties.fontFamily || defaultFontFamily};`}
  >
    {#each properties.sentences as sentence}
      <Sentence {sentence} />
    {/each}
  </div>
</Element>
